export default __webpack_public_path__ + "static/media/background-home-sm.d9e5197f.png";